// extracted by mini-css-extract-plugin
module.exports = {"header":"TripShowContainer_header__6V3w4"};